import { createSlice } from "@reduxjs/toolkit";

const scoreCard = {};
const todayScoreCard= {}
const scoreCardSlice = createSlice({
    name: "scorecard",
    initialState: {
        scoreCard,
        todayScoreCard,
        currentTab:null
    },
    reducers: {
        reSetScoreCardData(state, action){
            state.scoreCard = {};
            state.todayScoreCard= {};
            state.currentTab = null
        },
        setScoreCardData(state, action) {
            state.scoreCard = action.payload;
        },
        setTodayScoreCardData(state, action) {
            state.todayScoreCard = action.payload;
        },
        setCurrentTab(state,action){
            state.currentTab = action?.payload
        }
    },
});


export const {
    setScoreCardData,
    setTodayScoreCardData,
    setCurrentTab,
    reSetScoreCardData
} = scoreCardSlice.actions;

export default scoreCardSlice.reducer;
